var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEscalator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.686 24.56H71.698a14.416 14.416 0 0 0-10.261 4.252L49.099 41.15v-6.561a5.994 5.994 0 1 0-11.988 0v18.55L25.202 65.048a1.102 1.102 0 0 1-.784.324h-8.103c-5.674 0-10.29 4.616-10.29 10.29s4.616 10.29 10.29 10.29h11.072a14.42 14.42 0 0 0 10.262-4.25l36.239-36.237c.206-.206.492-.324.785-.324h9.015c5.674 0 10.29-4.616 10.29-10.29s-4.616-10.29-10.291-10.29Zm0 17.58h-9.015c-1.098 0-2.13.427-2.906 1.203L35.526 79.58a11.44 11.44 0 0 1-8.141 3.371H16.313c-4.02 0-7.29-3.271-7.29-7.29s3.271-7.29 7.29-7.29h8.103a4.08 4.08 0 0 0 2.905-1.203l36.237-36.235a11.433 11.433 0 0 1 8.14-3.372h11.988c4.02 0 7.291 3.27 7.291 7.289s-3.271 7.29-7.29 7.29ZM43.104 27.537a5.994 5.994 0 1 0 0-11.988 5.994 5.994 0 0 0 0 11.988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalator);
export default __webpack_public_path__ + "static/media/escalator.9507d46e14a5d16682e50e63999e2e3d.svg";
export { ForwardRef as ReactComponent };